import actions from './actions';

const initState = { users: null };

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.USER_FIELDS_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        fieldgroups: action.fieldgroups,
      };
    case actions.USERS_SUCCESS:
      return { ...state, users: action.users };
    case actions.USER_LOOKUP_SUCCESS:
      return { ...state, userLookupSuccess: action.userLookupSuccess };
    case actions.USER_CREATE_SUCCESS:
      return { ...state, userCreateSuccess: action.userCreateSuccess };
    case actions.USER_UPDATE_SUCCESS:
      return { ...state, userUpdateSuccess: action.userUpdateSuccess };
    case actions.USER_DELETE_SUCCESS:
      return { ...state, userDeleteSuccess: action.userDeleteSuccess };
    case actions.USER_ERROR:
      return { ...state, userError: action.userError };
    case actions.USER_MASSUPDATE_SUCCESS:
      return { ...state, userMassUpdateSuccess: action.userMassUpdateSuccess };
    case actions.USER_IMPORT_SUCCESS:
      return { ...state, userImportSuccess: action.userImportSuccess };
      case actions.USER_RESET_CHALLENGE_ANSWERS_SUCCESS:
        return { ...state, userResetChallengeAnswersSuccess: action.userResetChallengeAnswersSuccess };
    case actions.USER_IMPORT_ERROR:
      return { ...state, userImportError: action.userImportError };
    default:
      return state;
  }
}
